// A 🏠 anywhere in an address label marks it PRIVATE — typically someone's
// home address. Product rule (2026-08-24): a private address must never be
// shown on /profile. It IS still shown everywhere else in this app (the
// Users address book, the PAYMENTS address picker) so it stays manageable —
// only /profile hides it. The DAO storefront goes further and strips private
// addresses from every API payload (see daowatches_frontend
// src/helpers/privateAddress.js), and the backend refuses to write through a
// private default (UserService::updateAddress), so all three layers key on
// this same marker.
const HOME_EMOJI = "\u{1F3E0}"; // 🏠

export const isPrivateAddress = (address) =>
  !!address &&
  typeof address === "object" &&
  typeof address.label === "string" &&
  address.label.includes(HOME_EMOJI);
